import { ConfirmDelete } from "components/ConfirmDialog/ConfirmDelete";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { useApi } from "providers";
import { useMeetings } from "providers";
import { useToasts } from "providers";
import { useTranslations } from "providers";
import { useMeeting } from "providers";
import { useCallback } from "react";

export const ConfirmDeleteMeeting: React.FC = () => {
  const i18n = useTranslations();
  const toasts = useToasts();
  const { meetingApi } = useApi();
  const { confirmDeleteMeeting, setConfirmDeleteMeeting, setMeetingDeleting } = useMeeting();
  const { reloadMeetings } = useMeetings();

  const isOpen = confirmDeleteMeeting !== undefined;

  const handleDelete = useCallback(
    async (target?: ConfirmDeleteTarget) => {
      if (!target) return;

      setConfirmDeleteMeeting(undefined);
      setMeetingDeleting(target.id, true);

      try {
        await meetingApi.delete(target.id);
      } catch (error) {
        toasts.deleteFailure(i18n.Meeting, target.title, error);
      } finally {
        reloadMeetings().finally(() => {
          setMeetingDeleting(target.id, false);
        });
      }
    },
    [meetingApi, setMeetingDeleting, setConfirmDeleteMeeting, i18n, toasts, reloadMeetings]
  );

  const setIsOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        setConfirmDeleteMeeting(undefined);
      }
    },
    [setConfirmDeleteMeeting]
  );

  return (
    <ConfirmDelete
      entityName={i18n.Meeting}
      entityTitle={confirmDeleteMeeting?.title}
      content={i18n.Actions_Delete_Meeting_Confirm}
      onAccept={() => handleDelete(confirmDeleteMeeting)}
      onCancel={() => setConfirmDeleteMeeting(undefined)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};
